import { usePathHelper } from '@/hooks/usePathHelper'
import { useRouteOrganizationIdParam } from '@/hooks/useRouteOrganizationId'
import type { useFsnIncomingOrder } from '@/lib/services/fsn-network/fsn-network.query'
import { Link } from '@tanstack/react-router'
import { ExternalLink } from 'lucide-react'

type FsnWireInSourceLinkProps = {
  incomingOrderId?: Parameters<typeof useFsnIncomingOrder>[0] | null
}

export function FsnWireInSourceLink({ incomingOrderId }: FsnWireInSourceLinkProps) {
  const path = usePathHelper()
  const orgId = useRouteOrganizationIdParam()

  if (!incomingOrderId) {
    return null
  }

  return (
    <Link
      {...path.wireIn.index().using({ orgId }).search({ incomingOrderId }).link}
      className="inline-flex items-center gap-1.5 text-sm font-medium text-info underline-offset-4 hover:underline"
    >
      View original wire-in details
      <ExternalLink className="size-3.5" aria-hidden="true" />
    </Link>
  )
}
